import Home from "./Home"
import Settings from "./Settings"

export { Home, Settings }
export default Home
